import { useCurrentUser } from 'Auth';

import { Filter } from '@gogame/filters';

const UserFilter = (props) => {
  const { id } = useCurrentUser();

  return (
    <Filter.MultiSelect
      favorits={[id]}
      favoritsLabel={'Select me'}
      {...props}
    />
  );
};

export default UserFilter;
